import * as stylex from '@stylexjs/stylex';

import { Icon, type IconProps } from '@/libs/serenity-ui';
import { $ } from '@/libs/serenity-ui/tokens.stylex';

export function Logo(props: IconProps) {
  return (
    <Icon isColored size={{ width: 84, height: 18 }} {...props}>
      <svg fill="none" viewBox="0 0 84 18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.05423 13.9329V5.97276H7.8416V4.06738H0.0710449V5.97276H2.85842V13.9329H5.05423Z"
          {...stylex.props(styles.text)}
        />
        <path
          clipRule="evenodd"
          d="M14.7111 10.4049C15.9592 9.94403 16.5836 8.92293 16.5836 7.34238C16.5836 6.19441 16.2572 5.36209 15.6053 4.84467C14.9533 4.32724 13.8619 4.06815 12.3326 4.06815H8.60207V13.9329H10.7979V10.7855H12.3181L14.5001 13.9329H17.2027L14.7111 10.4049ZM14.345 7.34925C14.345 7.8812 14.2089 8.2687 13.9368 8.51327C13.6647 8.75861 13.1534 8.88013 12.4021 8.88013H10.7971V5.95901H12.4442C13.1481 5.95901 13.6411 6.0576 13.9223 6.25555C14.2036 6.4535 14.345 6.81807 14.345 7.34925Z"
          {...stylex.props(styles.text)}
          fillRule="evenodd"
        />
        <path
          d="M25.0856 4.06738V6.02932H20.1865V8.06157H24.5926V9.93868H20.1865V11.9855H25.24V13.9329H17.9906V4.06738H25.0856Z"
          {...stylex.props(styles.text)}
        />
        <path
          d="M35.4318 4.06738H33.236V10.4187L28.4072 4.06738H26.352V13.9321H28.5478V7.75051L33.2352 13.9321H35.431V4.06738H35.4318Z"
          {...stylex.props(styles.text)}
        />
        <path
          clipRule="evenodd"
          d="M44.5253 5.35904C45.4631 6.21963 45.9332 7.41728 45.9332 8.95045C45.9332 10.4836 45.4761 11.6981 44.5605 12.5915C43.6456 13.4858 42.2493 13.9321 40.3729 13.9321H37.0085V4.06738H40.4853C42.2401 4.06738 43.5868 4.49768 44.5253 5.35904ZM42.9134 11.2227C43.453 10.7144 43.7228 9.97613 43.7228 9.007C43.7228 8.03788 43.453 7.29193 42.9134 6.76992C42.3739 6.24791 41.5461 5.98652 40.4287 5.98652H39.2036V11.9847H40.5969C41.6012 11.9847 42.3731 11.7309 42.9127 11.2227H42.9134Z"
          {...stylex.props(styles.text)}
          fillRule="evenodd"
        />
        <path
          d="M74.9597 0.0302734H58.4907C53.5369 0.0302734 49.521 4.04616 49.521 9.00001C49.521 13.9539 53.5369 17.9697 58.4907 17.9697H74.9597C79.9135 17.9697 83.9294 13.9539 83.9294 9.00001C83.9294 4.04616 79.9135 0.0302734 74.9597 0.0302734Z"
          fill="#B80008"
        />
        <path
          d="M62.063 9.46927L59.5286 4.04967H56.5586V13.9152H58.7544V7.70528L61.4011 13.0966H62.7104L65.3709 7.70528V13.9152H67.5667V4.04967H64.6104L62.063 9.46927Z"
          fill="white"
        />
        <path
          d="M76.8727 5.34133C75.9342 4.48073 74.5875 4.04967 72.8327 4.04967H69.3559V13.9144H72.7203C74.5974 13.9144 75.9938 13.468 76.9079 12.5738C77.8227 11.6804 78.2805 10.4659 78.2805 8.93274C78.2805 7.39957 77.8113 6.20192 76.8727 5.34133ZM75.2608 11.205C74.7212 11.7132 73.9493 11.967 72.945 11.967H71.5509V5.96881H72.7753C73.892 5.96881 74.7205 6.2302 75.2601 6.75221C75.7989 7.27422 76.0694 8.02017 76.0694 8.9893C76.0694 9.95842 75.7997 10.6967 75.2608 11.205Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
}

const styles = stylex.create({
  text: {
    fill: $.textPrimary,
  }
});
